import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DisplayTypeService } from '../../../services/rest/display-type.service';
import { AuthUtils } from '../../../utils/AuthUtils';
import { PermissionTargetEnum } from '../../../enums/PermissionTargetEnum';
import { InputButtonIconType } from '../../core/button/button.utils';

@Component({
  selector: 'app-display-type-create',
  templateUrl: './display-type-create.component.html',
  styleUrls: ['./display-type-create.component.scss'],
})
export class DisplayTypeCreateComponent implements OnInit {
  InputButtonIconType = InputButtonIconType;
  userCanEdit: boolean = AuthUtils.canEdit(PermissionTargetEnum.DISPLAY_TYPE);
  form: FormGroup;
  loading = false;
  error: string | null = null;

  constructor(
    private fb: FormBuilder,
    private service: DisplayTypeService,
    private router: Router
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      code: ['', Validators.required],
    });
  }

  ngOnInit(): void {}

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const val = this.form.value;
    this.service.create(val).subscribe(
      () => this.router.navigate(['/display-type']),
      (err) => (this.error = 'Fehler beim Speichern')
    );
  }

  cancel(): void {
    this.router.navigate(['/display-type']);
  }
}
